// Card documenti obbligatori dello step di progettazione con stato caricamento
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Alert, AlertDescription } from '../ui/alert';
import { Badge } from '../ui/badge';
import { FileText, CheckCircle2, Info } from 'lucide-react';

export function RequiredDocumentsCard({ requiredDocuments, documents }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileText className="h-5 w-5" />
          Documentazione Tecnica
        </CardTitle>
        <CardDescription>
          Carica i documenti obbligatori per completare lo step
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {requiredDocuments.map(doc => {
            const uploaded = documents.find(d =>
              d.document_type?.toLowerCase() === doc.code?.toLowerCase()
            );

            return (
              <div key={doc.code} className="flex items-center justify-between p-4 border rounded-lg">
                <div className="flex items-center gap-3">
                  <FileText className={`h-5 w-5 ${uploaded ? 'text-green-500' : 'text-gray-400'}`} />
                  <div>
                    <p className="font-medium">{doc.label}</p>
                    {doc.description && (
                      <p className="text-sm text-muted-foreground">{doc.description}</p>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  {doc.required && (
                    <Badge variant="outline" className="text-red-600 border-red-300">
                      Obbligatorio
                    </Badge>
                  )}
                  {uploaded ? (
                    <Badge className="bg-green-100 text-green-800">
                      <CheckCircle2 className="h-3 w-3 mr-1" />
                      Caricato
                    </Badge>
                  ) : (
                    <Badge variant="outline" className="text-gray-500">
                      Da caricare
                    </Badge>
                  )}
                </div>
              </div>
            );
          })}

          <Alert>
            <Info className="h-4 w-4" />
            <AlertDescription>
              Utilizza la tab &quot;Documenti&quot; dello step per caricare i file richiesti.
            </AlertDescription>
          </Alert>
        </div>
      </CardContent>
    </Card>
  );
}
